module.exports = __webpack_public_path__ + "order/img/us.c22e6f33.svg";